import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectGameIds } from '../../state';
import GamesGrid from '../GamesGrid/GamesGrid';

function AllGames() {
  const allGames = useSelector(selectGameIds);

  return (
    <GamesGrid
      gameIds={allGames}
      loading={!allGames.length}
      contentContainerStyle={{
        paddingTop: 'space-400',
        paddingBottom: 'safe-area-inset-bottom',
        paddingHorizontal: 'space-600',
      }}
      imageType="square"
    />
  );
}

export default memo(AllGames);
